import {
  AGE,
  AGES,
  MARITAL_STATUS,
  PARTNER_NAME,
  TAX_FILING_STATE,
  INCOME,
  EXPENSES,
  CHILDREN,
  CHILDREN_DETAILS,
  HEALTHCARE_START_AT_RETIREMENT,
  HEALTHCARE_ANNUAL_EXPENSE,
  EARMARKED_ACCOUNTS,
} from '../SummaryConstants';

const DICTIONARY = {
  [MARITAL_STATUS]: {
    iterator: [0, 0],
    title: 'Partner',
  },
  [PARTNER_NAME]: {
    iterator: [0, 1],
    title: "Partner's Name",
  },
  [AGES]: {
    iterator: [0, 2],
    title: 'Ages',
  },
  [AGE]: {
    iterator: [0, 2],
    title: 'Age',
  },
  [CHILDREN]: {
    iterator: [0, 3],
    title: 'Children',
  },
  [CHILDREN_DETAILS]: {
    iterator: [0, 4],
    title: 'Children Details',
  },
  [TAX_FILING_STATE]: {
    iterator: [1, 0],
    title: 'Tax Filing State',
  },
  [INCOME]: {
    iterator: [2, 0],
    title: 'Income',
  },
  [EXPENSES]: {
    iterator: [3, 0],
    title: 'Expenses',
  },
  [HEALTHCARE_START_AT_RETIREMENT]: {
    iterator: [4],
    title: 'Start Year',
  },
  [HEALTHCARE_ANNUAL_EXPENSE]: {
    iterator: [5],
    title: 'Annual Expense',
  },
  [EARMARKED_ACCOUNTS]: {
    iterator: [6, 1],
    title: 'Earmarked Accounts',
  },
};
export default DICTIONARY;
